export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M19.526 3.418a.75.75 0 0 1 1.056 1.056l-.052.056L13.06 12l7.47 7.47.052.056a.75.75 0 0 1-1.056 1.056l-.056-.052L12 13.06l-7.47 7.47-.056.052a.75.75 0 0 1-1.056-1.056l.052-.056L10.94 12 3.47 4.53l-.052-.056a.75.75 0 0 1 1.056-1.056l.056.052L12 10.94l7.47-7.47.056-.052Z"/>
</svg>
`;
